import http from "../http";

export async function updateFieldMapping(epId, data) {
  const config = {
    params: { epId: epId }
  };
  const response = await http.put(`/batch/field-mapping`, data, config);
  return response.data;
}

export async function getFieldMapping(epId) {
  const config = {
    params: { epId: epId }
  };
  const response = await http.get(`/batch/field-mapping`, config);
  return response.data;
}

export async function uploadTestFile(data) {
  const response = await http.post(`/batch/test/upload`, data);
  return response.data;
}

export async function getMappedData(data) {
  const response = await http.post(`/batch/test/show-map-fields`, data);
  return response.data;
}

export async function runTestMatch(data) {
  const response = await http.post(`/batch/test/match`, data);
  return response.data;
}

export async function getTestMatch(data) {
  const response = await http.post(`/batch/test/match/status`, data);
  return response.data;
}
